import { render, staticRenderFns } from "./recentlyBrowse.vue?vue&type=template&id=5249e261&"
import script from "./recentlyBrowse.vue?vue&type=script&lang=js&"
export * from "./recentlyBrowse.vue?vue&type=script&lang=js&"
import style0 from "./recentlyBrowse.vue?vue&type=style&index=0&id=5249e261&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports